"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorsProvider = exports.useActorsContext = exports.ACTOR_SDK_VERSION = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const controlCenter_1 = require("src/declarations/controlCenter");
const management_1 = require("src/declarations/management");
const analyticsStore_1 = require("src/declarations/analyticsStore");
const promiseUtilsTypescript_1 = require("src/hello_assets/src/components/system/util/promiseUtilsTypescript");
const canisters_1 = require("src/hello_assets/src/util/canisters");
const App_1 = require("../../ui/App");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
exports.ACTOR_SDK_VERSION = 1;
const ActorsContext = React.createContext(undefined);
const useActorsContext = () => {
    const context = React.useContext(ActorsContext);
    if (!context) {
        throw new Error("useActorsContext must be used within a ActorsContext.Provider");
    }
    return context;
};
exports.useActorsContext = useActorsContext;
const ActorsProvider = (props) => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const createActorWithReusedPromise = (0, react_1.useMemo)(() => {
        return (0, promiseUtilsTypescript_1.reusePromiseWrapper)(authProviderContext.createActor);
    }, [authProviderContext.createActor]);
    const getControlCenterActor = (0, use_custom_compare_1.useCustomCompareCallback)(async () => {
        return getActor(canisters_1.Canisters.controlCenter, controlCenter_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const getManagementActor = (0, use_custom_compare_1.useCustomCompareCallback)(async () => {
        return getActor(canisters_1.Canisters.management, management_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const getAnalyticsStoreActor = (0, use_custom_compare_1.useCustomCompareCallback)(async (canisterId) => {
        if (process.env.NODE_ENV === "development") {
            if (lodash_1.default.isEmpty(canisterId)) {
                debugger;
            }
        }
        return getActor(canisterId, analyticsStore_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getControlCenterActor,
        getManagementActor,
        getAnalyticsStoreActor,
    }), [
        getControlCenterActor,
        getManagementActor,
        getAnalyticsStoreActor,
    ], lodash_1.default.isEqual);
    return React.createElement(ActorsContext.Provider, { value: value }, props.children);
};
exports.ActorsProvider = ActorsProvider;
const getActor = async function (canisterId, idlFactory, identity, createActorFn) {
    let actor = App_1.actorsByCanisterId[canisterId];
    if (actor) {
        //reuse actor
        // if (!!process.env.IS_TEST_SERVER) {
        //     console.log(`getActor[${canisterId}]: reuse actor`);
        // }
        return actor;
    }
    // if (!!process.env.IS_TEST_SERVER) {
    //     console.log(`getActor[${canisterId}]: ask for actor`);
    // }
    actor = await createActorFn(canisterId, idlFactory, {
        agentOptions: {
            identity: identity
        }
    });
    App_1.actorsByCanisterId[canisterId] = actor;
    // if (!!process.env.IS_TEST_SERVER) {
    //     console.log(`getActor[${canisterId}]: new actor`, actor);
    // }
    return actor;
};
